import { PopupV2 as AnimatedPopup } from '../../subComponents/popup';
import { IPopup } from '../../../constants/commonPortal.constant';

export const Popup = ({
  popup = IPopup(),
}) => {
  return (
    <AnimatedPopup
      open={popup.open}
      title={popup.title}
      type={popup.type}
      onClose={popup.onOk}
    >
      <div className='flex flex-column'>
        <div className='flex align-items-center font-roboto'>
          <div className='flex align-items-center'>{popup.message}</div>
        </div>
      </div>
    </AnimatedPopup>
  );
};

export default Popup;
